import bottleFactory from './bottle';

const bottle = bottleFactory();

const {
  spottingGroupAddRecord,
  spottingGroupUpdateRecord,
  spottingGroupRemoveRecords,
  spottingGroupFetchRecord,
  spottingGroupFetchAll,
  spottingGroupModel,
  recordToID,
} = bottle.container;

export default spottingGroupModel;

export {
  spottingGroupAddRecord,
  spottingGroupUpdateRecord,
  spottingGroupRemoveRecords,
  spottingGroupFetchRecord,
  spottingGroupFetchAll,
  recordToID,
};
